<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Invoice #SKUP4545</h5>
                  </div>
                  <small class="text-truncate text-muted">PAYMENTS</small>
                </div>
              </div>
            </div>
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="btn btn-sm btn-dark" href="javascript:void(0)">Create new</a>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">List view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Grid view</a>
                      <a class="dropdown-item" href="javascript:void(0)">Add new</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>

            </div>

          </div> <!-- .row end -->

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <!-- Invoice:  -->
          <div class="row justify-content-center py-lg-5 py-2">
            <div class="col-md-8 col-sm-12">
              <div class="card mb-4">
                <div class="card-body p-5">

                  <!-- Invoice: Header -->
                  <div class="row">

                    <div class="col-md-6 col-sm-12">
                      <img src="assets/images/logo-icon-color.svg" width="40" height="40" alt="logo" border="0">
                      <div class="mt-4 text-muted">
                        Hello, Philip Brooks.
                        <br> Thank you for shopping from our store and for your order.
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12 text-md-right">
                      <h3 class="text-danger mb-4">Invoice</h3>
                      <p class="mb-0">ORDER #800000025</p>
                      <small>MARCH 4TH 2016</small>
                    </div>

                  </div> <!-- .row end -->

                  <!-- Invoice: billing info -->
                  <div class="row">

                    <div class="col-md-6 col-sm-12 mt-md-5 mt-3">
                      <p class="mb-0">BILLING INFORMATION</p>
                      <div class="mt-1 text-muted small">
                        Philip Brooks<br>
                        Public Wales, Somewhere<br>
                        New York NY<br>
                        4468, United States<br>
                        T: 202-555-0133
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12 text-md-right mt-md-5 mt-3">
                      <p class="mb-0">PAYMENT METHOD</p>
                      <div class="mt-1 text-muted small">
                        Credit Card<br>
                        Credit Card Type: Visa<br>
                        Worldpay Transaction ID: <a href="javascript:void(0)">4185939336</a> <br>
                        Right of Withdrawal
                      </div>
                    </div>

                  </div> <!-- .row end -->

                  <!-- Invoice: table -->
                  <div class="row mt-md-5 mt-3">
                    <div class="col-12">
                      <table class="table table-bordered border-top-0 card-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">DESCRIPTION</th>
                            <th scope="col">HOURS</th>
                            <th class="text-end" scope="col">COST</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-primary font-weight-normal">Custom ANgular theme development</td>
                            <td>168</td>
                            <td class="text-end">$7,500</td>
                          </tr>
                          <tr>
                            <td class="text-primary font-weight-normal">iOS app design</td>
                            <td>80</td>
                            <td class="text-end">$2,000</td>
                          </tr>
                          <tr>
                            <td class="text-primary font-weight-normal">React Webapp with Laravel</td>
                            <td>235</td>
                            <td class="text-end">$8,150</td>
                          </tr>
                        </tbody>
                        <tbody class="border-0">
                          <td colspan="2"><strong>Total amount due</strong></td>
                          <td class="text-end">
                            <h5 class="mb-0">$7,000</h5>
                          </td>
                        </tbody>
                      </table>
                      <div class="mt-4">
                        <span class="text-muted">Note:</span>
                        <p class="small">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots
                          in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
                        <p class="text-info mt-5 small">Have a nice day!!!</p>
                      </div>
                    </div>
                  </div> <!-- .row end -->

                </div>
              </div>

              <div class="mb-5">
                <a class="btn btn-primary" href="javascript:void(0)!">Pay</a>
                <a class="btn btn-white border" href="javascript:void(0)">Download</a>
              </div>
            </div>
          </div> <!-- .row end -->

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
